import { Helmet } from 'react-helmet';
import styles from './styles.module.scss';

export const PageHome = () => {
  return (
    <>
      <Helmet>
        <title>고객을 끌어오는 구글 애널리틱스4</title>
      </Helmet>
      <div className={styles.wrapCover}>
        <img className={styles.cover} src="https://www.turtlebooks.co.kr/ga4/meta.png" />
      </div>
      <div style={{marginTop: 20, textAlign: 'left', fontSize: 20}}>
        <a href="/ga4/update">업데이트 내역 확인하기</a>
      </div>
    </>
  )
}
